const isRecord = (value: unknown): value is Record<string, unknown> =>
  value !== null && typeof value === 'object' && !Array.isArray(value);

// A workspace refresh replaces the whole auth workspace, so a sparse response
// must not be treated as a complete replacement.
export const isUsableWorkspace = (
  workspace: unknown,
  expectedId?: string,
): workspace is Record<string, any> =>
  isRecord(workspace) &&
  typeof workspace.id === 'string' &&
  workspace.id.length > 0 &&
  (!expectedId || workspace.id === expectedId) &&
  typeof workspace.name === 'string' &&
  isRecord(workspace.config) &&
  isRecord(workspace.billing) &&
  isRecord(workspace.settings);

export const isUsableAuth = (auth: unknown): auth is Record<string, any> =>
  isRecord(auth) &&
  isRecord(auth.user) &&
  isUsableWorkspace(auth.user.workspace);

export const parseStoredAuth = (raw: string | null): Record<string, any> | null => {
  if (!raw) return null;

  try {
    const auth = JSON.parse(raw);
    return isUsableAuth(auth) ? auth : null;
  } catch {
    return null;
  }
};
